import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const state = {
  activeModal: null,
  user: null,
  isCm: false,
  canvasInput: {
    input1: '',
    input2: '',
  },
  canvasOutput: {
    output1: null,
    output2: null,
    output3: null,
  },
  canvas1Image: null,
  canvas1: {
    lines: [
      { id: 0, title: 'Chest', length: 100 },
      { id: 1, title: 'Waist', length: 100 },
      { id: 2, title: 'Height', length: 200, vertical: true },
    ]
  },
  canvas2Image: null,
  canvas2: {
    lines: [
      { id: 3, title: 'Chest', length: 100 },
      { id: 4, title: 'Waist', length: 100 },
      { id: 5, title: 'Height', length: 200, vertical: true },
    ]
  },
  prevValues: null
}

const mutations = {
  setActiveModal(state, newModal) {
    state.activeModal = newModal;
/*     const eventName = 'cwh-' + String(newModal);
    this.$gtag.event(eventName, {
      'event_category': 'documentation',
      'event_label': 'submit-click button',
      'value': 1
    }) */
  },

  closeModal(state) {
    state.activeModal = null
  },

  setUser(state, user) {
    state.user = user
  },

  setCanvasOutput(state, data) {
    state.canvasOutput = { ...state.canvasOutput, ...data }
  },

  setIsCm(state, data) {
    if (data) {
      state.canvasInput.input1 = Number(state.canvasInput.input1)
        ? Number(state.canvasInput.input1) * 2.54
        : state.canvasInput.input1
      state.canvasInput.input2 = Number(state.canvasInput.input2)
        ? Number(state.canvasInput.input2) * 0.453592
        : state.canvasInput.input2
    } else {
      state.canvasInput.input1 = Number(state.canvasInput.input1)
        ? Number(state.canvasInput.input1) / 2.54
        : state.canvasInput.input1
      state.canvasInput.input2 = Number(state.canvasInput.input2)
        ? Number(state.canvasInput.input2) / 0.453592
        : state.canvasInput.input2
    }
    state.isCm = data
  },

  setCanvas1Image(state, data) {
    state.canvas1Image = data
  },

  setCanvas1(state, data) {
    state.canvas1 = data
  },

  setCanvas2Image(state, data) {
    state.canvas2Image = data
  },

  setCanvas2(state, data) {
    state.canvas2 = data
  },

  setCanvasInput(state, data) {
    state.canvasInput = data
  },

  resetImage(state) {
    if (state.activeModal === 'MobileCanvas1') {
      state.canvas1Image = null
    }
    if (state.activeModal === 'MobileCanvas2') {
      state.canvas2Image = null
    }
  },

  setPrevValues(state, data) {
    state.prevValues = data
  }
}

const actions = {
  async submitCanvasInput({ state, commit }) {
    const { input1, input2 } = state.canvasInput;
    var cm = state.isCm;
    var vertLineFront = state.canvas1.lines[2].length;
    var vertLineSide = state.canvas2.lines[2].length;
    var bustFrontPixelLength = state.canvas1.lines[0].length;
    var bustSidePixelLength = state.canvas2.lines[0].length;
    var waistFrontPixelLength = state.canvas1.lines[1].length;
    var waistSidePixelLength = state.canvas2.lines[1].length;
  

    await axios.post(process.env.VUE_APP_SERVER + '/canvas.php', {
      input1, 
      input2, 
      cm,
      vertLineFront,
      vertLineSide,
      bustFrontPixelLength,
      bustSidePixelLength,
      waistFrontPixelLength,
      waistSidePixelLength,

    }).then(({ data }) => {
      console.log("data", data)
      const { output1, output2 } = data
      commit('setCanvasOutput', { output1, output2})
    })
  }
}



export default new Vuex.Store({
  state,
  mutations,
  actions,
})
